import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';

// Services
import { LivestocktypeInsertService } from '../../service/livestocktype-insert/livestocktype-insert.service';

@Component({
	selector: 'app-livestocktype-insert',
	templateUrl: './livestocktype-insert.component.html',
	providers: [
		LivestocktypeInsertService,
		HttpModule
	]
})
export class LivestocktypeInsertComponent implements OnInit {

	private token;
	public permissoes: any[] = [];
	liveForm: FormGroup;
	Tipo: string = "";
	UnidadeMedida: string = "";
	statusLive: boolean;

	constructor(fb: FormBuilder, private livestocktypeInsertService: LivestocktypeInsertService, private flashMessagesService: FlashMessagesService, private router: Router) {
		this.token = localStorage.getItem('yara.token');
		this.liveForm = fb.group({
			'Tipo': [null, Validators.compose([Validators.required, Validators.maxLength(120)])],
			'UnidadeMedida': [null, Validators.compose([Validators.required, Validators.maxLength(120)])],
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
	}

	addLive(value: any) {
		this.livestocktypeInsertService.insertLive(this.token, value).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show('Tipo de Pecuária cadastrado com sucesso', { cssClass: 'alert-success', timeout: 6000 });
				this.router.navigateByUrl('/tipo-pecuaria');
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			
		});
	}

	cancelInsertEdit() {
		this.router.navigateByUrl('/tipo-pecuaria');
	}

}



// WEBPACK FOOTER //
// ./src/app/livestocktype/component/livestocktype-insert/livestocktype-insert.component.ts